//@flow
import React from "react";

export function ButtonTradeAccountOnly() {
  return (
    <button className="trade-only" disabled="disabled">
      Trade Only
    </button>
  );
}
